import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withTranslations from '../../utils/HighOrderComponent';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import { rowsPerPageOptions } from '../../constants/globals.js';
import { TablePagination } from '@material-ui/core';
import { changePaginationTextToSerbian } from '../../utils';
import {
  findAllPlacePageable,
  findAllPlaceFilterPageable,
  updatePlace,
  createPlace,
} from '../../actions/place';
import PlaceTable from '../Place/PlaceTable';

class PlaceList extends Component {
  constructor() {
    super();
    this.state = {
      showPlace: false,
      placeforEdit: null,
    };
  }

  componentDidMount() {
    this.props.findAllPlacePageable(0, this.props.pageSize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetData) {
      const postData = {
        tableName: 'place',
        filterCriteria: [{ returnAllSignal: true }],
      };
      this.props.findAllPlaceFilterPageable(0, nextProps.pageSize, postData);
      nextProps.setResetData(false);
    }
  }

  handleFindAllTrigger = (pageNumber, pageSize) => {
    this.props.findAllPlacePageable(pageNumber, pageSize);
  };

  handlePageChange = (event, value) => {
    const {
      setActivePage,
      postData,
      pageSize,
      findAllPlacePageable,
      findAllPlaceFilterPageable,
    } = this.props || {};
    setActivePage(value);
    postData
      ? findAllPlaceFilterPageable(value, pageSize, postData)
      : findAllPlacePageable(value, pageSize);
  };

  handleClose = () => {
    this.setState({ showPlace: false, placeforEdit: null });
  };

  handleOpen = (placeforEdit) => {
    this.setState({ showPlace: true, placeforEdit: placeforEdit });
  };

  handleChangeRowsPerPage = (event, value) => {
    const { setPageSize, setActivePage, postData, findAllPlaceFilterPageable } =
      this.props || {};
    setPageSize(event.target.value);
    setActivePage(0);
    postData
      ? findAllPlaceFilterPageable(0, event.target.value, postData)
      : this.handleFindAllTrigger(0, event.target.value);
  };

  render() {
    const {
        t,
        place,
        placeList,
        updatePlace,
        createPlace,
        activePage,
        pageSize,
      } = this.props || {},
      { totalElements, loading } = place || {};

    if (loading) {
      return <LoadingIndicator />;
    }

    return (
      <Fragment>
        <PlaceTable
          placeList={placeList}
          updatePlace={updatePlace}
          createPlace={createPlace}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <TablePagination
            component="div"
            count={Number(totalElements)}
            page={activePage}
            onPageChange={this.handlePageChange}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPage={pageSize}
            labelRowsPerPage={t.rowPerPage}
            labelDisplayedRows={(obj) =>
              changePaginationTextToSerbian(obj, t.of)
            }
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  place: state.place,
  placeList: state.place.placeList || [],
  loggedUser: state.loggedUser?.loggedUser,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllPlacePageable: (pageNumber, pageSize) => {
      dispatch(findAllPlacePageable(pageNumber, pageSize));
    },
    updatePlace: (place, callback, messages) => {
      dispatch(updatePlace(place, callback, messages));
    },
    createPlace: (place, callback, messages) => {
      dispatch(createPlace(place, callback, messages));
    },
    findAllPlaceFilterPageable: (
      pageNumber,
      pageSize,
      postData,
      successCallback
    ) => {
      dispatch(
        findAllPlaceFilterPageable(
          pageNumber,
          pageSize,
          postData,
          successCallback
        )
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(PlaceList, 'PlaceList'));
